import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_STOCK_INDICES } from '../../../../config/tables'

export default function IndicesDeMermaCalidadView () {
  return <MuiTable id={TABLA_STOCK_INDICES} />
}
